// Shared helpers, the drawing surface and the action clock.

import { clockNow, frame } from './clock.js';
export { clockNow, frame } from './clock.js';

export const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));
export const rand = (a, b) => a + Math.random() * (b - a);
export const chance = p => Math.random() < p;
export const pick = list => list[Math.floor(Math.random() * list.length)];
export const lerp = (a, b, t) => a + (b - a) * t;
export const easeInOut = t => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
export const easeOut = t => 1 - (1 - t) * (1 - t);

export function hash(a, b, c) {
  let h = Math.imul(a | 0, 374761393) + Math.imul(b | 0, 668265263) + Math.imul(c | 0, 2246822519);
  h = Math.imul(h ^ (h >>> 13), 1274126177);
  return ((h ^ (h >>> 16)) >>> 0) / 4294967296;
}

export function weighted(items, weightOf) {
  const total = items.reduce((s, it) => s + weightOf(it), 0);
  if (total <= 0) return null;
  let k = Math.random() * total;
  for (const it of items) if ((k -= weightOf(it)) <= 0) return it;
  return items[items.length - 1];
}

// One place for the canvas and the owner's size choice, so every module reads the same values.
// S is screen pixels per crab pixel. unit is canvas pixels per size step (the host's pixelScale,
// runtime/README.md): S is the owner's size times unit, rounded to whole pixels.
export const env = { ctx: null, W: 0, H: 0, S: 5, MIN_S: 3, MAX_S: 8, unit: 1 };

// Each companion runs one action at a time. A run token g = { me, n } belongs to one run of
// one companion; starting a new run bumps me.gen, and the old run stops at its next frame by
// throwing Cancelled. Companions never interrupt each other.
export class Cancelled extends Error {}
export function startRun(me) { me.gen = (me.gen || 0) + 1; return { me, n: me.gen }; }
export const isCurrent = g => g.n === g.me.gen;
const nextFrame = () => new Promise(r => frame(r));
export async function tick(g) { await nextFrame(); if (g.n !== g.me.gen) throw new Cancelled(); }
// A token can carry a tempo: its waits and animations take that many times as long (a god's
// attacks in a duel: fights.js).
export async function wait(ms, g) { const end = clockNow() + ms * (g.tempo ?? 1); while (clockNow() < end) await tick(g); }

// Runs fn(t) every frame for t from 0 to 1 over ms.
export async function animate(ms, g, fn) {
  const t0 = clockNow();
  for (;;) {
    await tick(g);
    const t = Math.min(1, (clockNow() - t0) / (ms * (g.tempo ?? 1)));
    fn(t);
    if (t >= 1) return;
  }
}
